import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-view-notif-content',
  templateUrl: './form-view-notif-content.component.html',
  styleUrls: ['./form-view-notif-content.component.scss']
})
export class FormViewNotifContentComponent implements OnInit {
  @Input() notification:any
  constructor() { }

  ngOnInit(): void {
  }

}
